/* eslint-disable */
import { parseFullSymbol, makeApiRequest } from './helpers.js'

const channelToSubscription = new Map()

// auto update last bar as miliseconds
const AUTO_UPDATE = 60000

export function subscribeOnStream(
	symbolInfo,
	resolution,
	onRealtimeCallback,
	subscriberUID,
	onResetCacheNeededCallback,
	lastDailyBar,
) {
	const parsedSymbol = parseFullSymbol(symbolInfo.full_name)
	const channelString = `${parsedSymbol.exchange}~${parsedSymbol.fromSymbol}~${parsedSymbol.toSymbol}`
	const handler = {
		id: subscriberUID,
		callback: onRealtimeCallback,
	}

	let subscriptionItem = channelToSubscription.get(channelString)
	if (subscriptionItem) {
		// Already subscribed to the channel, use the existing subscription
		// console.log("Already subscribed to the channel, use the existing subscription")
		subscriptionItem.handlers.push(handler)
		return
	}
	subscriptionItem = {
		subscriberUID,
		resolution,
		lastDailyBar,
		handlers: [handler],
	}

	channelToSubscription.set(channelString, subscriptionItem)
	// console.log('[subscribeBars]: Subscribe to streaming. Channel:', channelString)

	updateChart(channelString)
}

function updateChart (channelString) {
	setInterval(() => {
		const urlParams = new URLSearchParams(window.location.search)		
		const market = urlParams.get('pair')
		const from = urlParams.get('from')
		const to = urlParams.get('to')
		const countBack = 2
		
		const url = `?market=${market}&from=${from}&to=${to}&countback=${countBack}`
		const data = makeApiRequest(urlParams.get('type'), url)

		makeApiRequest(urlParams.get('type'), url).then((resp) => {
			if (resp.t.length < 1) {
				return
			}

			const tradePrice = parseFloat(resp.c[1])
			const subscriptionItem = channelToSubscription.get(channelString)
			if (subscriptionItem === undefined) {
				return
			}

			const lastDailyBar = subscriptionItem.lastDailyBar

			let bar
			bar = {
				...lastDailyBar,
				high: Math.max(lastDailyBar.high, tradePrice),
				low: Math.min(lastDailyBar.low, tradePrice),
				close: tradePrice,
			}

			// console.log('[socket] Update the latest bar by price', tradePrice)
			subscriptionItem.lastDailyBar = bar
			subscriptionItem.handlers.forEach(handler => handler.callback(bar))
		})
	}, AUTO_UPDATE)
}

export function unsubscribeFromStream(subscriberUID) {
	// Find a subscription with id === subscriberUID
	for (const channelString of channelToSubscription.keys()) {
		const subscriptionItem = channelToSubscription.get(channelString)
		const handlerIndex = subscriptionItem.handlers
			.findIndex(handler => handler.id === subscriberUID)

		if (handlerIndex !== -1) {
			// Remove from handlers
			subscriptionItem.handlers.splice(handlerIndex, 1)

			if (subscriptionItem.handlers.length === 0) {
				// Unsubscribe from the channel if it was the last handler
				// console.log('[unsubscribeBars]: Unsubscribe from streaming. Channel:', channelString)
				channelToSubscription.delete(channelString)
				break
			}
		}
	}
}
/* eslint-disable */
